import { useQuery } from '@tanstack/react-query';
import { ctcApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Cost-detail transactions behind one CTC cost code. */
export function useCtcBreakdown(
  jobNumber: string | null | undefined,
  costCode: string | null | undefined,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.ctc.breakdown(jobNumber ?? '', costCode ?? ''),
    queryFn: ({ signal }) =>
      ctcApiClient.getJobBreakdown(
        jobNumber!,
        costCode!,
        toCancelToken(signal),
      ),
    enabled: enabled && !!jobNumber && !!costCode,
    staleTime: 0,
    meta: { errorContext: 'CTC cost code breakdown' },
  });
}
